import { FetchPolicy } from "@apollo/client";
import { UserDataFragment, useGetAllUsersQuery } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { MagnifyingGlassIcon, SingleGroupedSelect } from "@bonliva-crm/ui";
import { Box, makeStyles } from "@material-ui/core";
import { createGroupedUserOptions } from "./utils/create-grouped-user-options";
import { ComponentProps } from "react";

type Props = {
  fetchPolicy?: FetchPolicy;
  value: UserDataFragment | null;
  onChange: (user: UserDataFragment | null) => void;
} & Omit<ComponentProps<typeof SingleGroupedSelect<Option>>, "value" | "onChange">;

type Option = {
  label: string;
  value: UserDataFragment;
};

export function UserSearchSingle(props: Props) {
  const { fetchPolicy, value, onChange, ...selectProps } = props;
  const classes = useStyles();
  const users = useGetAllUsersQuery({
    fetchPolicy: fetchPolicy ?? "cache-first"
  });

  const inputOptions = createGroupedUserOptions(users.data?.users || []);

  return (
    <SingleGroupedSelect<Option>
      placeholder={
        <Box className={classes.placeholder}>
          <MagnifyingGlassIcon />
          {locale.Search}...
        </Box>
      }
      isSearchable={true}
      options={inputOptions}
      value={value ? { label: value.Name, value: value } : null}
      isClearable={true}
      maxMenuHeight={2000}
      onChange={(option) => onChange(option?.value || null)}
      styleProps={{ menu: { showBorder: true }, control: { showBorder: true } }}
      closeMenuOnSelect={true}
      autoFocus={true}
      openMenuOnFocus={true}
      controlShouldRenderValue={true}
      backspaceRemovesValue={true}
      {...selectProps}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  placeholder: {
    display: "flex",
    columnGap: "0.5rem",
    alignItems: "center"
  }
}));
